export default "__VITE_PUBLIC_ASSET__814fa201__"